import clsx from "clsx";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Ref } from "react";
import styles from "./SmetaButton.module.css";

export type SmetaButtonVariant = "contained" | "outlined";
export type SmetaButtonColor = "primary" | "success" | "warning" | "error" | "info";
export type SmetaButtonSize = "small" | "medium" | "large";

export interface SmetaButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: SmetaButtonVariant;
  color?: SmetaButtonColor;
  size?: SmetaButtonSize;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  fullWidth?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SmetaButton = ({
  children,
  className,
  color = "primary",
  endIcon,
  fullWidth = false,
  size = "medium",
  startIcon,
  type = "button",
  variant = "contained",
  ref,
  ...buttonProps
}: SmetaButtonProps) => (
  <button
    {...buttonProps}
    ref={ref}
    type={type}
    className={clsx(
      styles.root,
      styles[variant],
      styles[color],
      styles[size],
      fullWidth && styles.fullWidth,
      className,
    )}
  >
    {startIcon !== undefined && <span className={styles.icon}>{startIcon}</span>}
    <span className={styles.label}>{children}</span>
    {endIcon !== undefined && <span className={styles.icon}>{endIcon}</span>}
  </button>
);

SmetaButton.displayName = "SmetaButton";

export default SmetaButton;
